/* eslint-disable no-magic-numbers */
import { formatNumber } from '@omnipresentgroup/design-system';
import { type ClientPolicyPeriod, PayTypeEnum } from '@omnipresentgroup/types';

const getClientPolicyPeriodDescription = (period: ClientPolicyPeriod) => {
  const start = period.start;
  const end = period.end;
  const unit = period.unit;
  const payType = period.payDetails.payType;

  const unitText = `${unit}s`.toLocaleLowerCase();
  const policyDurationText =
    start === 1
      ? `for the first ${end} ${unitText}`
      : `for ${unitText} ${start} - ${end}`;

  if (payType === PayTypeEnum.FIXED) {
    return `${formatNumber({
      input: period.payDetails.fixedValue.amount as number,
      currency: period.payDetails.fixedValue.currency,
    })} ${policyDurationText}`;
  }

  return `${period.payDetails.percentageValue}% ${policyDurationText}`;
};

export const getClientPolicyDescription = (periods: ClientPolicyPeriod[]) =>
  periods
    .map((period) => getClientPolicyPeriodDescription(period))
    .join(' and ');
